export const useBase64Converter = () => {
  const arrayBufferToBase64 = async (arrayBuffer: ArrayBuffer): Promise<string> => {
    try {
      const base64String = btoa(
        new Uint8Array(arrayBuffer).reduce((data, byte) => data + String.fromCharCode(byte), '')
      );

      return base64String;
    } catch (error) {
      console.error('Erro na conversão de base64:', error);
      throw error;
    }
  };

  const base64ToArrayBuffer = (base64: string): ArrayBuffer => {
    const binaryString = atob(base64.split(',')[1]);
    const len = binaryString.length;
    const bytes = new Uint8Array(len);

    for (let i = 0; i < len; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }
    return bytes.buffer;
  };

  const base64ToFile = (base64: string, mimeType: string, fileName: string): File => {
    const arrayBuffer = base64ToArrayBuffer(base64);
    const blob = new Blob([arrayBuffer], { type: mimeType });
    return new File([blob], fileName, { type: mimeType });
  };

  const cleanBase64Prefix = (base64: string): string => {
    return base64.split(',')[1];
  };

  return {
    arrayBufferToBase64,
    base64ToArrayBuffer,
    base64ToFile,
    cleanBase64Prefix,
  };
};
